import { preload } 			from './modules/mod_preload'
import { nav } 				from './modules/mod_nav'
import { slider } 			from './modules/mod_slider'
import { lightbox } 		from './modules/mod_lightbox'
import { counter } 			from './modules/mod_counter'
import { macy } 			from './modules/mod_macy';
import { aos } 				from './modules/mod_aos';

window.onload = function () {
	preload()
	nav()
	slider()
	lightbox()
	counter()
	macy()
	aos()
}